<template>
  <el-dialog
    v-loading="loading"
    :title="$t(`${apiPrefix}dialog.title`)"
    :visible.sync="visible"
    custom-class="rwd-dialog"
    @close="close"
  >
    <el-dialog
      custom-class="rwd-dialog"
      :title="$t(`${apiPrefix}dialog.title`)"
      :visible.sync="innerVisible"
      append-to-body
    >
      <h3 v-if="resMsg" class="dialog-msg">
        <i v-if="isSuccess" class="el-icon-success"></i>
        <i v-else class="el-icon-error"></i>
        <span v-html="resMsg"></span>
      </h3>
      <span v-if="detailMsg" v-html="detailMsg"></span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="innerVisible = false">
          {{ $t('api.confirmBtn') }}
        </el-button>
      </span>
    </el-dialog>
    <el-form :model="formData" ref="formData">
      <el-row
        v-if="acceptExt === '.xlsx'"
        :gutter="20"
      >
        <el-col :xs="24">
          <remote-opt
            v-model="formData.brand_id"
            :base="base"
            name="brand"
            :labelArr="['id', 'name']"
            :fetchList="fetchBrandList"
            :required="true"
            :isAutoFetch="true"
          >
          </remote-opt>
        </el-col>
        <el-col :xs="24">
          <remote-opt
            v-model="formData.tz_location"
            base="region"
            name="tz_location"
            prop="tz_location"
            inputStore="Timezone"
            :required="true"
          >
          </remote-opt>
        </el-col>
        <el-col :xs="24">
          <el-form-item
            :label="$t(`${apiPrefix}dialog.fileUpload`)"
            required
          >
            <el-upload
              :action="importURL"
              :data="formData"
              :auto-upload="false"
              :with-credentials="true"
              :accept="acceptExt"
              :on-change="onChange"
              :on-success="onSuccess"
              :on-error="onError"
              :limit="1"
              ref="upload"
            >
              <el-button slot="trigger" type="primary">
                {{ $t(apiPrefix + 'dialog.selectFile') }}
              </el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-tabs
        v-else
        style="margin-top: 0;"
        v-model="activeTab"
      >
        <el-tab-pane
          :label="$t('api.payment.name')"
          name="payment"
        >
          <el-row :gutter="20">
            <el-col :xs="24">
              <remote-opt
                v-model="formData.tz_location"
                base="region"
                name="tz_location"
                prop="tz_location"
                inputStore="Timezone"
                :required="true"
              >
              </remote-opt>
            </el-col>
            <el-col :xs="24">
              <el-form-item
                :label="$t(`${apiPrefix}dialog.fileUpload`)"
                required
              >
                <el-upload
                  :action="importUpdateURL"
                  :data="formData"
                  :auto-upload="false"
                  :with-credentials="true"
                  :accept="acceptExt"
                  :on-change="onChange"
                  :on-success="onSuccess"
                  :on-error="onError"
                  :limit="1"
                  ref="upload-payment"
                >
                  <el-button slot="trigger" type="primary">
                    {{ $t(apiPrefix + 'dialog.selectFile') }}
                  </el-button>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane
          :label="$t('api.optFields.platform.map.tableapp')"
          name="tableapp"
        >
          <el-row :gutter="20">
            <el-col :xs="24">
              <remote-opt
                v-model="formData.tz_location"
                base="region"
                name="tz_location"
                prop="tz_location"
                inputStore="Timezone"
                :required="true"
              >
              </remote-opt>
            </el-col>
            <el-col :xs="24">
              <el-form-item
                :label="$t(`${apiPrefix}dialog.fileUpload`)"
                required
              >
                <el-upload
                  :action="importURL"
                  :data="formData"
                  :auto-upload="false"
                  :with-credentials="true"
                  :accept="acceptExt"
                  :on-change="onChange"
                  :on-success="onSuccess"
                  :on-error="onError"
                  :limit="1"
                  ref="upload-tableapp"
                >
                  <el-button slot="trigger" type="primary">
                    {{ $t(apiPrefix + 'dialog.selectFile') }}
                  </el-button>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('api.cancelBtn') }}</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="submit"
        :disabled="submitDisabled"
      >
        {{ $t(`${apiPrefix}btn`) }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>

import { fetchList as fetchBrandList } from '@/api/setting/brand'
import { getLabelText, getOptMap } from '@/utils/i18n'
import { defCreate } from '@/api/default'
import { BranchPlatform } from '@/enums'

export default {
  name: 'import-dialog',
  props: {
    base: {
      type: String,
      required: true
    },
    getList: {
      type: Function,
      default: () => {}
    },
    path: {
      type: String,
      default: ''
    },
    acceptExt: {
      type: String,
      default: '.xlsx'
    }
  },
  data () {
    return {
      formValid: () => {},
      formData: {
        brand_id: 2,
        platform: BranchPlatform.tableapp,
        tz_location: 'Asia/Taipei'
      },
      fileList: [],
      loading: false,
      visible: false,
      isSuccess: false,
      activeTab: 'payment',
      resMsg: '',
      detailMsg: '',
      innerVisible: false
    }
  },
  computed: {
    apiPrefix () {
      switch (this.acceptExt) {
        case '.csv':
          return 'api.csvImport.'
        case '.xlsx':
        default:
          return 'api.xlsxImport.'
      }
    },
    uploadRefs () {
      if (this.acceptExt === '.xlsx') {
        return 'upload'
      }
      return 'upload-' + this.activeTab
    },
    msg () {
      if (this.activeTab === 'payment') {
        return 'import'
      }
      return 'msg'
    },
    importURL () {
      return process.env.BASE_API + this.path
    },
    importUpdateURL () {
      return process.env.BASE_API + this.path + '_update'
    },
    submitDisabled () {
      return this.fileList.length === 0
    },
    platformOpts () {
      return [BranchPlatform.tableapp]
    }
  },
  methods: {
    fetchBrandList,
    getLabelText,
    getOptMap,
    defCreate,
    show () {
      this.visible = true
      this.setFormDataBasedOnExt()
      let tz = Intl.DateTimeFormat().resolvedOptions().timeZone
      if (tz) {
        this.formData.tz_location = tz
      }
    },
    close () {
      this.$refs[this.uploadRefs].clearFiles()
      this.visible = false
    },
    onChange (file, fileList) {
      this.fileList = fileList
    },
    onSuccess (res) {
      this.loading = false
      this.close()
      if (res) {
        this.handleOnSuccessMsg(res)
      }
      this.isSuccess = true
      this.innerVisible = true
      this.getList()
    },
    handleOnSuccessMsg (res) {
      let msg = ''
      let resMsg = ''
      switch (this.acceptExt) {
        case '.csv':
          resMsg = this.$t(`${this.apiPrefix}${this.msg}.success`)
          break
        case '.xlsx':
          if (res.data) {
            if (res.data.success_idxs) {
              resMsg = this.$t(`${this.apiPrefix}msg.success`, {
                cnt: res.data.success_idxs.length
              })
            }
            if (res.data.error_data && res.data.error_data.length > 0) {
              msg += '<h4>' + this.$t(`${this.apiPrefix}msg.errorData`) + '</h4>'
              msg += '<p>'
              Object.keys(res.data.error_data).forEach(key => {
                msg += '<b>' + key + '</b> - ' + res.data.error_data[key] + '<br/>'
              })
              msg += '</p>'
            }
          }
          break
        default:
          return msg
      }
      this.resMsg = resMsg
      this.detailMsg = msg
    },
    onError (err) {
      this.loading = false
      this.handleOnErrorMsg(err)
      this.isSuccess = false
      this.innerVisible = true
    },
    handleOnErrorMsg (err) {
      let resMsg = ''
      let msg = ''
      switch (this.acceptExt) {
        case '.csv':
          resMsg = this.$t(`${this.apiPrefix}${this.msg}.error`)
          let m = JSON.parse(err.message)
          if (m.errs) {
            Object.keys(m.errs).forEach(key => {
              msg += '<b>' + key + '</b> - ' + m.errs[key] + '<br/>'
            })
          }
          break
        case '.xlsx':
          resMsg = this.$t(`${this.apiPrefix}msg.error`)
          let res = JSON.parse(err.message)
          if (res.message) {
            msg += '<h4>' + res.message + '</h4>'
          }
          if (res.errs) {
            Object.keys(res.errs).forEach(key => {
              msg += '<b>' + key + '</b> - ' + res.errs[key] + '<br/>'
            })
          }
          break
        default:
          return msg
      }
      this.resMsg = resMsg
      this.detailMsg = msg
    },
    submit () {
      this.loading = true
      this.$refs[this.uploadRefs].submit()
    },
    setFormDataBasedOnExt () {
      switch (this.acceptExt) {
        case '.csv':
          this.formData = {
            tz_location: 'Asia/Kuala_lampur'
          }
          break
        case '.xlsx':
          this.formData = {
            brand_id: 2,
            tz_location: 'Asia/Taipei'
          }
          break
        default:
          this.formData = {}
      }
    }
  },
  watch: {
    acceptExt (newVal) {
      this.setFormDataBasedOnExt()
    }
  }
}
</script>
